import Swiper, {Autoplay, Pagination, EffectFade, A11y} from "../../../_snowpack/pkg/swiper.js";
async function playActiveVideoSlide(swiper) {
  const currentSlide = swiper.slides[swiper.activeIndex];
  const currentVideoElement = document.querySelector(".entity-slider--video .swiper-slide-active .entity-slider--video__video");
  const playButton = currentSlide.querySelector(".video-play-button");
  if (currentVideoElement) {
    currentVideoElement.currentTime = 0;
    const videoDuration = Math.round(currentVideoElement.duration * 1e3);
    swiper.autoplay.stop();
    swiper.params.autoplay = {
      delay: videoDuration,
      disableOnInteraction: false
    };
    swiper.autoplay.start();
    await currentVideoElement.play().then(() => {
      if (!!playButton && !playButton.classList.contains("hidden")) {
        playButton.classList.add("hidden");
      }
    }).catch((error) => {
      console.log(error);
      if (!!playButton) {
        playButton.classList.remove("hidden");
        playButton.onclick = () => {
          swiper.autoplay.stop();
          currentVideoElement.play().then(() => {
            playButton.classList.add("hidden");
            swiper.autoplay.start();
          }).catch((e) => console.error(e));
        };
      }
    });
  } else {
    swiper.autoplay.start();
  }
}
function pauseAllVideoSlides() {
  document.querySelectorAll(".entity-slider--video .entity-slider--video__video").forEach((videoElement) => {
    videoElement.pause();
    videoElement.currentTime = 0;
  });
}
function handleVideoPlayback(videoElement) {
  const threshold = 0.1;
  videoElement.addEventListener("timeupdate", () => {
    const timeToEnd = videoElement.duration - videoElement.currentTime;
    if (timeToEnd <= threshold) {
      videoElement.pause();
    }
  });
}
const initializeVideoSlider = (slider) => {
  slider.querySelectorAll(".entity-slider--video__video").forEach((video) => {
    video.removeAttribute("preload");
    handleVideoPlayback(video);
  });
  const firstVideo = slider.querySelector(".entity-slider--video__video");
  const lang = document.documentElement.lang;
  firstVideo.play().then(() => {
    const swiperContainer = slider.querySelector(".swiper-container");
    new Swiper(swiperContainer, {
      modules: [Pagination, Autoplay, EffectFade, A11y],
      a11y: lang === "de" ? {
        paginationBulletMessage: "Gehe zu Folie {{index}}",
        firstSlideMessage: "Dies ist die erste Folie",
        prevSlideMessage: "Vorherige Folie",
        lastSlideMessage: "Dies ist die letzte Folie",
        slideLabelMessage: "{{index}} / {{slidesLength}}",
        nextSlideMessage: "Nächste Folie"
      } : {
        paginationBulletMessage: "Go to slide {{index}}",
        firstSlideMessage: "This is the first slide",
        prevSlideMessage: "Previous slide",
        lastSlideMessage: "This is the last slide",
        slideLabelMessage: "{{index}} / {{slidesLength}}",
        nextSlideMessage: "Next slide"
      },
      pagination: {
        el: ".swiper-pagination",
        type: "bullets",
        clickable: true
      },
      effect: "fade",
      fadeEffect: {crossFade: true},
      virtualTranslate: true,
      slidesPerView: 1,
      spaceBetween: 0,
      centerInsufficientSlides: true,
      loop: swiperContainer.dataset.loop === "1",
      autoplay: {
        delay: Math.round(firstVideo.duration * 1e3),
        disableOnInteraction: false
      },
      on: {
        afterInit: () => {
          firstVideo.currentTime = 0;
          swiperContainer.classList.add("video-initialized");
        },
        transitionEnd(swiper) {
          pauseAllVideoSlides();
          playActiveVideoSlide(swiper);
        }
      }
    });
  }).catch((error) => {
    console.info("Auto-play was prevented");
  });
};
if (window.innerWidth > 1023) {
  document.querySelectorAll(".entity-slider--video").forEach((videoSlider) => initializeVideoSlider(videoSlider));
} else {
  document.querySelectorAll(".ce--sitepackage_dsmw_heroVideoSlider").forEach((videoEntitySlider) => videoEntitySlider.classList.add("hidden"));
}
